// extracted by mini-css-extract-plugin
export default {"page-container":"Home_page-container__krzJm","content-container":"Home_content-container__IG-xk","footer":"Home_footer__auSkY"};